import React, { useState } from "react";
import { ChevronDown, ChevronUp, X, Image } from 'lucide-react';
import toast from "react-hot-toast";

export default function ReviewsSection({ reviews, newReview, setNewReview, submitReview }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState([]);

  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    
    // Limit to 3 photos
    if (selectedPhotos.length + files.length > 3) {
      toast.error('Maximum 3 photos allowed');
      return;
    }

    files.forEach(file => {
      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('Image size should be less than 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        setSelectedPhotos(prev => [...prev, event.target.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removePhoto = (index) => {
    setSelectedPhotos(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    // Pass photos along with review
    submitReview(selectedPhotos);
    setSelectedPhotos([]);
    setIsExpanded(false);
  };

  const handleCancel = () => {
    setIsExpanded(false);
    setSelectedPhotos([]);
  };

  return (
    <div className="mt-20 px-6 sm:px-12 max-w-7xl mx-auto">
      <h3 className="text-2xl font-bold mb-6">Customer Reviews</h3>

      {/* Show reviews */}
      {/* <div className="max-h-[32rem] overflow-y-auto space-y-6 mb-6">
        {reviews.length === 0 ? (
          <p className="text-gray-500">No reviews yet. Be the first to review!</p>
        ) : (
          reviews.map((rev, idx) => (
            <div key={idx} className="border p-6 rounded-lg">
              <p className="font-medium">{rev.name}</p>
              <p className="text-sm text-gray-500">
                {new Date(rev.createdAt).toLocaleDateString()}
              </p>

              <div className="flex items-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <span
                    key={i}
                    className={i < rev.rating ? "text-yellow-500 text-xl" : "text-gray-300 text-xl"}
                  >
                    ★
                  </span>
                ))}
              </div> */}

              {/* <p className="mt-2 mb-3">{rev.comment}</p> */}

              {/* Review Photos */}
              {/* {rev.photos && rev.photos.length > 0 && (
                <div className="flex gap-2 flex-wrap mt-3">
                  {rev.photos.map((photo, photoIdx) => (
                    <img
                      key={photoIdx}
                      src={photo}
                      alt={`Review ${photoIdx + 1}`}
                      className="w-24 h-24 object-cover rounded border cursor-pointer hover:opacity-80 transition"
                      onClick={() => {
                        const win = window.open('', '_blank');
                        win.document.write(`
                          <html>
                            <head><title>Review Image</title></head>
                            <body style="margin:0;display:flex;justify-content:center;align-items:center;background:#000;">
                              <img src="${photo}" style="max-width:100%;max-height:100vh;object-fit:contain;" />
                            </body>
                          </html> */}
                        {/* `);
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div> */}

      {/* Leave Review Button */}
      {!isExpanded && (
        <button
          onClick={() => setIsExpanded(true)}
          className="flex items-center gap-2 bg-black text-white px-6 py-3 rounded font-medium hover:bg-gray-800 transition"
        >
          Leave a Review
          <ChevronDown className="w-5 h-5" />
        </button>
      )}

      {/* Review Form - Collapsible */}
      {isExpanded && (
        <div className="border border-gray-200 rounded-lg p-6 mt-4">
          <div className="flex justify-between items-center mb-4">
            <h4 className="text-xl font-medium">Leave a Review</h4>
            <button
              onClick={handleCancel}
              className="text-gray-500 hover:text-black transition"
            >
              <ChevronUp className="w-5 h-5" />
            </button>
          </div>

          <input
            type="text"
            placeholder="Your Name"
            className="w-full border px-4 py-3 rounded mb-4 focus:border-black focus:outline-none transition"
            value={newReview.name}
            onChange={(e) => setNewReview({ ...newReview, name: e.target.value })}
          />

          <select
            className="border px-3 py-2 rounded mb-4 focus:border-black focus:outline-none transition"
            value={newReview.rating}
            onChange={(e) => setNewReview({ ...newReview, rating: +e.target.value })}
          >
            {[5, 4, 3, 2, 1].map((r) => (
              <option key={r} value={r}>
                {r} Star{r > 1 && "s"}
              </option>
            ))}
          </select>

          <textarea
            className="w-full border px-4 py-3 rounded mb-4 focus:border-black focus:outline-none transition resize-none"
            rows="4"
            placeholder="Write your review..."
            value={newReview.comment}
            onChange={(e) => setNewReview({ ...newReview, comment: e.target.value })}
          />

          {/* Photo Upload Section */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Add Photos (Optional - Max 3)</label>
            
            {/* Photo Preview */}
            {selectedPhotos.length > 0 && (
              <div className="flex gap-2 mb-3 flex-wrap">
                {selectedPhotos.map((photo, idx) => (
                  <div key={idx} className="relative">
                    <img
                      src={photo}
                      alt={`Preview ${idx + 1}`}
                      className="w-24 h-24 object-cover rounded border"
                    />
                    <button
                      onClick={() => removePhoto(idx)}
                      className="absolute -top-2 -right-2 bg-black text-white rounded-full p-1 hover:bg-gray-800 transition"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Upload Button */}
            {selectedPhotos.length < 3 && (
              <label className="flex items-center gap-2 border-2 border-dashed border-gray-300 px-4 py-3 rounded cursor-pointer hover:border-black transition">
                <Image className="w-5 h-5 text-gray-500" />
                <span className="text-sm text-gray-600">Upload Photos</span>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handlePhotoUpload}
                  className="hidden"
                />
              </label>
            )}
            <p className="text-xs text-gray-500 mt-2">JPG, PNG - Max 5MB per image</p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={handleSubmit}
              className="bg-black text-white px-6 py-3 rounded font-medium hover:bg-gray-800 transition"
            >
              Submit Review
            </button>
            <button
              onClick={handleCancel}
              className="border border-gray-300 px-6 py-3 rounded font-medium hover:bg-gray-50 transition"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <br />
      <br />
    </div>
  );
}